import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CurrencyCard from '../components/CurrencyCard';
import { FaSyncAlt } from 'react-icons/fa';
import { formatSourceUpdate, isCurrencyStale, isIstanbulMarketOpen } from '../utils/marketStatus';
import { dedupeAndSortAssets } from '../utils/assetDisplayOrder';

const AltinPage = () => {
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCurrencies();
    const interval = setInterval(fetchCurrencies, 5 * 60 * 1000); // 5 dakika
    return () => clearInterval(interval);
  }, []);

  const fetchCurrencies = async () => {
    try {
      const { data } = await axios.get('/api/currency');
      const altinlar = dedupeAndSortAssets(data.filter(c => c.category === 'gold' || c.category === 'silver'));
      setCurrencies(altinlar);
      setLoading(false);
    } catch (error) {
      console.error('Altın fiyatları yüklenemedi:', error);
      setLoading(false);
    }
  };

  // Altın kategorisi (TL bazlı)
  const altinlar = dedupeAndSortAssets(currencies.filter(c => c.category === 'gold'));

  // Gümüş kategorisi
  const gumusler = dedupeAndSortAssets(currencies.filter(c => c.category === 'silver'));

  const latestCurrency = currencies.reduce((latest, currency) => {
    if (!latest) return currency;
    return new Date(currency.fetchedAt || 0) > new Date(latest.fetchedAt || 0) ? currency : latest;
  }, null);
  const marketOpen = isIstanbulMarketOpen();
  const stale = isCurrencyStale(latestCurrency);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 py-8 transition-colors duration-300 ease-in-out">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-2">Altın ve Değerli Madenler</h1>
          <p className="text-gray-600 dark:text-gray-300 flex items-center space-x-2">
            <FaSyncAlt className="text-primary-600 dark:text-primary-400" />
            <span>Trunçgil kaynak zamanı: {formatSourceUpdate(latestCurrency)}</span>
            <span className={marketOpen && !stale ? 'text-green-600 dark:text-green-400 font-medium' : 'text-slate-500 dark:text-slate-400 font-medium'}>
              {stale ? 'Eski veri' : marketOpen ? 'Güncel' : 'Piyasa kapalı'}
            </span>
          </p>
        </div>

        {loading ? (
          <div className="flex justify-center items-center py-20">
            <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary-600"></div>
          </div>
        ) : (
          <div className="space-y-10">
            {/* Altın Kategorisi */}
            {altinlar.length > 0 && (
              <div>
                <h2 className="text-2xl font-bold text-yellow-600 dark:text-yellow-400 mb-4 flex items-center gap-2">
                  <span>🥇</span> Altın
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
                  {altinlar.map((currency) => (
                    <CurrencyCard key={currency.code} currency={currency} />
                  ))}
                </div>
              </div>
            )}

            {/* Gümüş Kategorisi */}
            {gumusler.length > 0 && (
              <div>
                <h2 className="text-2xl font-bold text-gray-500 dark:text-gray-300 mb-4 flex items-center gap-2">
                  <span>🥈</span> Gümüş / Metal
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
                  {gumusler.map((currency) => (
                    <CurrencyCard key={currency.code} currency={currency} />
                  ))}
                </div>
              </div>
            )}

          </div>
        )}
      </div>
    </div>
  );
};

export default AltinPage;
